import { FormattedMessage } from "react-intl";
import { Checkbox, Collapse } from "antd";
import countriesList from "../data/countries.json";
import { useMemo } from "react";

const { Panel } = Collapse;

const FiltersBox = (props) => {
  const {
    isResetBtnShow,
    resetFilters,
    importance,
    filterImportance,
    filterRegion,
    // g7_selected_num,
    // g7_list,
    countriesSelected,
    // european_union_selected_num,
    // european_union_list,
    // all_selected_num,
    // all_list,
  } = props;

  const getListSelectedNum = (list) => {
    let list_w_status = Object.fromEntries(
      Object.entries(countriesSelected).filter(([region, status]) =>
        list.includes(region)
      )
    );
    let selected_num = Object.values(list_w_status).filter(
      (item) => item === true
    ).length;

    return selected_num;
  };

  let g7_list = useMemo(() => countriesList.g7.map((item) => item.value), []);
  let g7_selected_num = getListSelectedNum(g7_list);

  let european_union_list = useMemo(
    () => countriesList.european_union.map((item) => item.value),
    []
  );
  let european_union_selected_num = getListSelectedNum(european_union_list);

  let all_list = useMemo(() => countriesList.all.map((item) => item.value), []);
  let all_selected_num = getListSelectedNum(all_list);

  return (
    <div className="col-lg-2 filtersBox px-0">
      <div className="filtersBoxTitle">
        <span>
          <FormattedMessage id="commons.filters" />
        </span>
        {isResetBtnShow && (
          <div className="reset_btn" onClick={resetFilters}>
            <FormattedMessage id="commons.reset" />
          </div>
        )}
      </div>
      <div className="filtersBox_section_divider">
        <div className="filtersBoxSubTitle mb-3">
          <FormattedMessage id="commons.importance" />
        </div>
        <div className="d-flex flex-row justify-content-around flex-wrap">
          <div
            id="low"
            className={`form-check filter_importance ${
              importance.includes("low") ? "selected" : ""
            }`}
            onClick={() => filterImportance("low")}
          >
            <FormattedMessage id="filters.low" />
          </div>
          <div
            id="medium"
            className={`form-check filter_importance ${
              importance.includes("medium") ? "selected" : ""
            }`}
            onClick={() => filterImportance("medium")}
          >
            <FormattedMessage id="filters.medium" />
          </div>
          <div
            id="high"
            className={`form-check filter_importance ${
              importance.includes("high") ? "selected" : ""
            }`}
            onClick={() => filterImportance("high")}
          >
            <FormattedMessage id="filters.high" />
          </div>
        </div>
      </div>
      <div className="filtersBox_section_divider">
        <div className="filtersBoxSubTitle">
          <FormattedMessage id="commons.countries" />
        </div>
      </div>
      <Collapse expandIconPosition="end" className="border-0">
        {/* <!-- G7 --> */}
        <Panel
          header={
            <Checkbox
              onChange={() => filterRegion("g7")}
              checked={g7_selected_num === g7_list.length}
              indeterminate={
                g7_selected_num !== 0 && g7_selected_num < g7_list.length
              }
            >
              G7
            </Checkbox>
          }
          key="1"
        >
          {countriesList.g7.map((item) => (
            <div className="my-2" key={item.value}>
              <Checkbox
                checked={countriesSelected[item.value]}
                onChange={() => filterRegion(item.value)}
              >
                <img
                  alt="flag"
                  className="flagImg"
                  src={`https://voyanceplus.co.uk/public/flags/4x3/${item.value.toLowerCase()}.svg`}
                />
                {item.label}
              </Checkbox>
            </div>
          ))}
        </Panel>
        {/* <!-- European Union --> */}
        <Panel
          header={
            <Checkbox
              onChange={() => filterRegion("european_union")}
              checked={
                european_union_selected_num === european_union_list.length
              }
              indeterminate={
                european_union_selected_num !== 0 &&
                european_union_selected_num < european_union_list.length
              }
            >
              European Union
            </Checkbox>
          }
          key="2"
        >
          {countriesList.european_union.map((item) => {
            let imageName =
              item.value === "EA" ? "eu" : item.value.toLowerCase();
            return (
              <div className="my-2" key={item.value}>
                <Checkbox
                  checked={countriesSelected[item.value]}
                  onChange={() => filterRegion(item.value)}
                >
                  <img
                    alt="test"
                    className="flagImg"
                    src={`https://voyanceplus.co.uk/public/flags/4x3/${imageName}.svg`}
                  />
                  {item.label}
                </Checkbox>
              </div>
            );
          })}
        </Panel>
        {/* All Countries */}
        <Panel
          header={
            <Checkbox
              onChange={() => filterRegion("all")}
              checked={all_selected_num === all_list.length}
              indeterminate={
                all_selected_num !== 0 && all_selected_num < all_list.length
              }
            >
              All Countries
            </Checkbox>
          }
          key="3"
        >
          {countriesList.all.map((item) => {
            let imageName =
              item.value === "EA" ? "eu" : item.value.toLowerCase();
            return (
              <div className="my-2" key={item.value}>
                <Checkbox
                  checked={countriesSelected[item.value]}
                  onChange={() => filterRegion(item.value)}
                >
                  <img
                    alt="test"
                    className="flagImg"
                    src={`https://voyanceplus.co.uk/public/flags/4x3/${imageName}.svg`}
                  />
                  {item.label}
                </Checkbox>
              </div>
            );
          })}
        </Panel>
      </Collapse>
    </div>
  );
};

export default FiltersBox;
